import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  RemoveAcceptedMutation as _RemoveAcceptedMutation,
  RemoveAcceptedInput,
} from '@/gql/graphql';

const RemoveAcceptedMutation = graphql(`
  mutation RemoveAccepted($input: RemoveAcceptedInput!) {
    removeAccepted(input: $input)
  }
`);

const useRemoveAccepted = (args?: {
  proposalId?: string;
  projectId?: string;
  options?: UseMutationOptions<
    _RemoveAcceptedMutation,
    unknown,
    RemoveAcceptedInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: RemoveAcceptedInput) => {
      return gqlClient.request(RemoveAcceptedMutation, { input });
    },
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.project(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useRemoveAccepted;
